import React, {FC, useEffect, useState} from "react"

import History from "@irati/utils/history"
import {Grid} from "react-bootstrap"
import {Col, Row} from "@irati/ui/src/ColumnRow"
import {WellnessMedia} from "@irati/types"
import {RouteComponentProps} from "react-router-dom"
import wellnessService from "@irati/wellness/services/Wellness"
import TermsAndConditionsSection from "../components/MediaPaywall/TermsAndConditionsSection"
import MediaRedemptionSection from "../components/MediaPaywall/MediaRedemptionSection"

interface Match {
  mediaId: string
}

interface Props extends RouteComponentProps<Match> {}

const MediaPaywall: FC<Props> = ({match}) => {
  const [media, setMedia] = useState<WellnessMedia>({})
  const [termsAgreed, setTermsAgreed] = useState(false)

  useEffect(() => {
    const {mediaId} = match.params
    wellnessService.getMediaById(mediaId).then((m) => {
      if (m.src?.length) {
        History.replace({
          pathname: `/wellness/details/${m.uuid}`
        })
        return
      }
      setMedia(m)
    })
  }, [])

  const toggleTermsAndConditions = () => {
    setTermsAgreed(!termsAgreed)
  }
  if (!media) {
    return null
  }
  return (
    <Grid>
      <Row marginTop={8}>
        <Col md={8}>
          <TermsAndConditionsSection onChange={toggleTermsAndConditions} termsAgreed={termsAgreed} />
        </Col>
        <Col md={4}>
          <MediaRedemptionSection media={media} />
        </Col>
      </Row>
    </Grid>
  )
}

export default MediaPaywall
